export const extractCurrencySymbol = (valueLabel: string | number) => {
  if (typeof valueLabel === "string" && valueLabel.includes("R$")) {
    return "R$";
  }
  return "";
};

export const extractValue = (valueLabel: string | number) => {
  if (typeof valueLabel === "string") {
    return valueLabel.replace(/R\$\s?/, "").trim();
  }
  return valueLabel.toString();
};
